module.exports = __webpack_public_path__ + "img/gift5.08a704b2.png";